module.exports = (__webpack_require__(1))(23);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/constants.js from dll-reference rlink_core
// module id = 13
// module chunks = 0